import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export const appActions = {
  //updateSelected: actionCreator<boolean>('ACTIONS_UPDATE_SELECTED'),
  toggleSelected: actionCreator<number>('ACTIONS_TOGGLE_SELECTED'),
};